import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GlobalContext } from './Context/GlobalContext';
import AuthProvider from './Context/AuthContext';
import { ClientContextProvider } from './Context/ClientContext';
import { PayrollContextComponent } from './Context/PayrollContext';
import { GoogleOAuthProvider } from '@react-oauth/google';


const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
  <GoogleOAuthProvider clientId="671164180097-m85hbtdcdv70dfo6i364llvv277dqpvi.apps.googleusercontent.com">
    <GlobalContext>
      <AuthProvider>
        <PayrollContextComponent>
          <ClientContextProvider>
            <App />
          </ClientContextProvider>
        </PayrollContextComponent>
      </AuthProvider>
    </GlobalContext>
  </GoogleOAuthProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
